export default __webpack_public_path__ + "static/media/creator_logo.4ffe355b.png";